/**
 * Register the service worker at /sw.js.
 *
 * Only registers when:
 *   1. The browser supports service workers (navigator.serviceWorker).
 *   2. We are in production (import.meta.env.PROD is true).
 *
 * This ensures the worker never caches anything during local development,
 * where stale caches would mask changes and cause confusing behavior.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) {
    return;
  }

  if (
    typeof navigator === 'undefined' ||
    !('serviceWorker' in navigator) ||
    !navigator.serviceWorker
  ) {
    return;
  }

  navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
    // Registration failure is non-fatal — the app still works, just without
    // offline support. Log so it shows up in production monitoring.
    console.warn('Service worker registration failed:', err);
  });
}
